module.exports = __webpack_public_path__ + "static/media/VirajW.1818146d.jpeg";